import { SDKConfig } from './interfaces/configuration';
import { Liquid } from './liquid';

export * from './api';
export * from './liquid';
export { buildItemIdentifier } from './functions';

declare global {
  interface Window {
    Liquid: (options: SDKConfig) => Promise<Liquid>;
    grecaptcha: any;
  }
}

const liquid = async (options: SDKConfig = {}): Promise<Liquid> => {
  const liquid = new Liquid(options);
  return liquid.authenticate();
};

try {
  window.Liquid = liquid;
} catch (e) {
  // window is not defined
}

export { liquid };
export default liquid;
